import React, { FC } from "react";
import icon from "../../../../assets/svg/Group48.svg";

const CloseIcon: FC = () => {
    return (
        <img src={icon} alt="close icon" style={{maxWidth: 25, objectFit: "contain"}}/>
    );
}

export default CloseIcon;